import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { normalizeHtmlSpaces } from "helpers/common";
import React from "react";
import Html from "react-pdf-html";

const styles = StyleSheet.create({
  listItem: {
    position: "relative",
    marginLeft: 14,
    marginBottom: 4,
    marginTop: 3
  },
  bullet: {
    position: "absolute",
    left: -10,
  },
  text: {
    // flex: 1,
  },
});

const renderers = {
  li: ({ children }) => (
    <View style={styles.listItem}>
      <Text style={styles.bullet}>•</Text>
      <View style={styles.text}>
        {Array.isArray(children)
          ? children.map((child, i) => (
              <React.Fragment key={i}>{child}</React.Fragment>
            ))
          : <Text>{children}</Text>}
      </View>
    </View>
  ),
};

const PDFHtmlRenderer = ({ style, data }) => {
  const content = normalizeHtmlSpaces(data);
  

  return (
    <Html
      renderers={renderers}
      stylesheet={{
        p: { marginBottom: 5, marginTop: 0 },
        ul: {
          margin: 0,
          paddingLeft: 0,
        },
      }}
      style={[style, { lineHeight: "13px" }]}
    >
      {content || ""}
    </Html>
  );
};

export default PDFHtmlRenderer;
